export default {"src":"/_next/static/media/upload_remix_image_icon.d157c151.svg","height":52,"width":50,"blurWidth":0,"blurHeight":0};